/**
 * One Escape press peels the top transient layer. Overlays and in-progress
 * pointer ops cancel before standing panels. After transients, a live object
 * or mesh-element selection is cleared. Idle Edit Mesh is last: Escape then
 * returns to Object Mode. Tab still toggles Edit Mesh directly.
 */
export function nextEscapeLayer({
  contextMenuOpen = false,
  mirrorOpen = false,
  addPaletteOpen = false,
  transformDragging = false,
  meshEditDragging = false,
  flyHeld = false,
  hasSelection = false,
  meshEditActive = false,
} = {}) {
  if (contextMenuOpen) return 'close-context-menu';
  if (mirrorOpen) return 'close-mirror';
  if (transformDragging) return 'cancel-transform';
  if (meshEditDragging) return 'cancel-mesh-edit';
  if (flyHeld) return 'exit-fly';
  if (addPaletteOpen) return 'close-add-palette';
  if (hasSelection) return 'clear-selection';
  if (meshEditActive) return 'exit-edit-mesh';
  return null;
}
